module.exports = __webpack_public_path__ + "img/why2.8de9881a.jpg";